<template>
    <v-card id="mapconteiner" elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container class="size" fluid>
            <v-layout row justify-start>
                <v-flex xs12 md12 pl-2>
                    <h3><b>Mortalidade</b></h3>
                </v-flex>
            </v-layout>
            <v-form v-model="isFormValid" ref="form">
                <v-layout row wrap justify-start v-if="$vuetify.breakpoint.smAndUp" class="pl-2">
                    <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                        <v-autocomplete v-on:keyup.enter="loadMortalidades" v-model="csStatus" :items="listaStatus"
                            color="primary" item-text="dsStatus" item-value="csStatus" label="Status do Lote"
                            no-data-text="Nenhum registro" outlined clearable>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                        <v-text-field v-on:keyup.enter="loadMortalidades" :rules="[campoMaiorOuIgualZero]" mask="########" type="number" v-model.number="min" label="Percentual mínimo" outlined clearable></v-text-field>
                    </v-flex>
                    <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                        <v-text-field v-on:keyup.enter="loadMortalidades" :rules="[campoMaiorOuIgualZero]" mask="########" type="number" v-model.number="max" label="Percentual máximo" outlined clearable></v-text-field>
                    </v-flex>
                    <v-flex class="item" lg3 md2 sm6 xs12 pa-1>
                        <v-autocomplete v-on:keyup.enter="loadMortalidades" v-model="csTipoUEP" :items="listaTipoUEP"
                            color="primary" item-text="dsTipoUEP" item-value="csTipoUEP" label="Tipo de Unidade Exploração"
                            no-data-text="Nenhum registro" outlined clearable>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex class="item" lg3 md3 sm3 xs12 pa-2>
                        <v-btn id="search" dark rounded color="primary" @click="loadMortalidades">
                            <span class="marginSpan"> Atualizar </span>
                            <v-icon small>fa-sync-alt</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <div id="mapdiv"></div>
        </v-container>
    </v-card>
</template>



<script>
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import chroma from "chroma-js"
import axios from "axios"
import { dateIsoToLocal, formatCPF } from '@/filters/utils'
import {campoMaiorOuIgualZero} from '@/filters/rules'

const offStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0
};

const onStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0.3
};

export default {
    data() {
        return {
            isFormValid: false,
            min: 0,
            max: 100,
            mapLayerControl: null,
            map: null,
            pontos: null,
            cityCodes: [],
            objMarkers: [],
            listaStatus: [
                {
                    csStatus: 'AB',
                    dsStatus: 'Aberto'
                },
                {
                    csStatus: 'FE',
                    dsStatus: 'Fechado'
                }
            ],
            csStatus: 'AB',
            listaTipoUEP: [
                {
                    csTipoUEP: 'UP',
                    dsTipoUEP: 'UPL'
                },
                {
                    csTipoUEP: 'CR',
                    dsTipoUEP: 'Creche'
                },
                {
                    csTipoUEP: 'TR',
                    dsTipoUEP: 'Terminação'
                },
                {
                    csTipoUEP: 'WF',
                    dsTipoUEP: 'Wean to Finish'
                }
            ],
            csTipoUEP: ''
        }
    },
    computed: {
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
    },
    mounted() {
        this.initComponent()
    },
  methods: {
        dateIsoToLocal,
        formatCPF,
        campoMaiorOuIgualZero,
        initComponent() {
            this.$store.dispatch('actLoadEstabelecimentos')
            this.initMap()
            this.loadMortalidades()
        },
        initMap() {
            this.map = L.map("mapdiv", {
                center: [-27.019984, -51.064453],
                zoom: 7,
                worldCopyJump: true
            })
            this.mapLayerControl = L.control.layers({}, {}).addTo(this.map)
            this.pontos = L.featureGroup().addTo(this.map)

            var openStreetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', 
                {
                    maxZoom: 12,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' + 
                    '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                })

            var streetBasicsLayer = L.tileLayer(
                "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                {
                    maxZoom: 18,
                    attribution:
                        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: "mapbox.streets-basic"
                }
            ).addTo(this.map)

            this.mapLayerControl.addBaseLayer(streetBasicsLayer, "Básico")
            this.mapLayerControl.addBaseLayer(openStreetLayer, "Detalhado")
            

            this.mapLayerControl.addOverlay(this.pontos, "Mortalidades")
        },
        insertMortalide(p) {
            // eslint-disable-next-line
            var scale = chroma.scale(["green", "yellow", "red", "#ab0000"]).domain([0, 3])
            var dtFechamento = p.dt_fechamento_lote
                ? "Fechamento: <b>" + this.dateIsoToLocal(p.dt_fechamento_lote) + "</b><br>" 
                : ""

            var nrAlojados = p.nr_alojados ? p.nr_alojados : "00"
            var produtor = p.nm_produtor ? p.nm_produtor : ''
            
            var text = "Produtor: <b>" + produtor + "</b><br>" +
                "Estabelecimento: <b>" + p.nm_estabelecimento + "</b> - <b>" + p.nr_codigo_oficial + "</b><br>" +
                "Nr. Controle: <b>" + p.nr_lote_controle + "</b><br>" +
                "Nr. Rastreabilidade: <b>" + p.nr_lote_rastreabilidade + "</b><br>" +
                "Abertura: <b>" + this.dateIsoToLocal(p.dt_criacao_lote) + "</b><br>" +
                dtFechamento +
                "Alojados: <b>" + nrAlojados  + "</b><br>" + 
                "Mortalidade: <b>" + p.vl_indice_mortalidade.toFixed(2) + '%' + "</b><br>" +
                "Clique " + "<b>duas vezes</b>" + " no marcador para ir para o Lote"

            var pointColor = scale(p.vl_indice_mortalidade).hex()

            var borda = true;
            if (!dtFechamento) {
                borda = false
            }
            var size = p.nr_alojados / 100
            if (size < 10) size = 10

            var group = this.objMarkers[p.estabelecimento.idEstabelecimento]

            if (group == undefined)
            {
                group = L.markerClusterGroup({
                    iconCreateFunction: function(cluster) {
                        var childCount = cluster.getChildCount()
                        var c = ' marker-cluster-'
                        if (childCount < 5) {
                            c += 'small'
                        } 
                        else if (childCount < 10) {
                            c += 'medium'
                        } 
                        else {
                            c += 'large'
                        }

                        return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', 
                            className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) })
                    }
                })

                this.pontos.addLayer(group)

                this.objMarkers[p.estabelecimento.idEstabelecimento] = group
            }

            if (p.nr_latitude != null && p.nr_longitude != null)
            {
                this.addLayer(p.nr_latitude, p.nr_longitude, size, pointColor, borda, text, group, p.id_lote_producao)
            }
            else
            {
                var estabelecimento = this.estabelecimentos.find(i => i.idEstabelecimento === p.estabelecimento.idEstabelecimento )

                if (estabelecimento != undefined && (estabelecimento.nrLatitude != null && estabelecimento.nrLongitude != null))
                {
                    this.addLayer(estabelecimento.nrLatitude, estabelecimento.nrLongitude, size, pointColor, borda, text, group, p.id_lote_producao)
                }
            }


        },
        addLayer(nrLatitude, nrLongitude, size, pointColor, borda, text, group, idLoteProducao) {
            group.addLayer(L.circleMarker([nrLatitude, nrLongitude], {
                radius: size,
                color: pointColor,
                fillColor: pointColor,
                stroke: borda,
                fillOpacity: 0.8,
            }).bindPopup(text).on('dblclick', L.bind(this.goToLoteProducao, null, idLoteProducao)))
        },
        goToLoteProducao(idLote) {
            this.$router.push({name: 'loteProducao', params: {id: idLote}})
        },
        loadMortalidades() {
            if (this.$refs.form.validate())
            {
                var context = this;
                this.pontos.clearLayers()

                this.min = this.min == "" ? 0 : this.min
                this.max = this.max == "" ? 0 : this.max

                axios.get("dashboard/lote-producao-geo-info/", {
                        params: {
                            fl_indice_mortalidade_min: parseFloat(this.min) || null,
                            fl_indice_mortalidade_max: parseFloat(this.max) || null,
                            fl_aberto: this.csStatus == 'AB' ? true : this.csStatus == 'FE' ? false : null,
                            cs_tipo_uep: this.csTipoUEP != '' ? this.csTipoUEP : null
                        }
                    })
                    .then(function(response) {
                        context.objMarkers = []
                        if (response.data[0].data != null)
                        {
                            response.data[0].data.forEach(p => {
                                context.insertMortalide(p)
                            })
                        }
                        // context.map.fitBounds(context.pontos.getBounds())
                    })
                    .catch(function(error) {
                        context.$store.commit("setSnack", { type: "error", msg: error })
                    });
                }
            }
        }
    };
</script>


<style>
#app {
  height: 100%;
  margin: 0;
}

#mapconteiner,
.size {
  height: 95%;
}
#mapdiv, #map {
    height: 93%;
    position: sticky !important;
}
.marginSpan {
    margin: 5px;
}
</style>
